/** @jsx jsx */
import React from 'react';
import { components } from '@atlaskit/select';
import { css, jsx } from '@emotion/react';
import { N200 } from '@atlaskit/theme/colors';
const spacing = 8;
const fontSize = 12;
const innerHeight = spacing * 2; // 16px
const lineHeight = innerHeight / fontSize;
const controlWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const getLabelStyle = () => css({
  color: `var(--ds-text-subtlest, ${N200})`,
  fontSize: `${fontSize}px`,
  fontWeight: 600,
  lineHeight: `${lineHeight}`,
  paddingBottom: "var(--ds-space-050, 4px)",
  paddingLeft: "var(--ds-space-0, 0px)",
  paddingRight: "var(--ds-space-0, 0px)",
  paddingTop: "var(--ds-space-250, 20px)"
});
export class PopupControl extends React.PureComponent {
  render() {
    const {
      selectProps: {
        popupTitle
      }
    } = this.props;
    return jsx("div", {
      css: controlWrapper
    }, jsx("div", {
      css: getLabelStyle()
    }, popupTitle), jsx(components.Control, this.props));
  }
}